export default __webpack_public_path__ + "static/person-game-3-0e97e416146d2ec15f3b13d82c3cbb16.png";